/**
 * Genera un slug estable para el campo `id` del grupo a partir del label.
 */
export function slugifyGroupId(label: string): string {
  const slug = label
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  return slug || "grupo";
}
